import { render } from "./BButton.vue?vue&type=template&id=96655d2e&scoped=true"
import script from "./BButton.vue?vue&type=script&lang=js"
export * from "./BButton.vue?vue&type=script&lang=js"

import "./BButton.vue?vue&type=style&index=0&id=96655d2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96655d2e"]])

export default __exports__